"use client";
import React, {
    ReactNode,
    useCallback,
    useEffect,
    useMemo,
    useState,
} from "react";
import { useFormStatus } from "react-dom";
// import { deleteRxN, rxFormEdit } from "@/src/models/lens/lensServer";
import { getRxN } from "@/src/models/lens/lensClient";
import { getCookieItem, setCookieItem } from "@/lib/commonService";

import { isLogin } from "@/src/models/loginModel";

import { getRxSelect } from "@/config/rx_config";

import RxConfirm from "./RxConfirm";
import { RX_COOKIE_NAME, RX_STR_COOKIE_NAME } from "@/config/constConf";

import {
    useCommonContext,
    usePrescriptionContext,
    useProductDetailsContext,
} from "@/src/provider";
import { getSiteConfiguration } from "@/src/utils/configUtils";
import { FmButton, FmInput, FmPicker, FmLink, FmDrawer } from "@/ui-component";
import classnames from "classnames";
import stl from "./rxForm.module.scss";
import { lensInfo, signInModal } from "@/store";
import Upload from "@/src/components/Upload";
import {
    IInsertGetPrescription,
    IPrescriptionDataItem,
    initActiveData,
} from "@/store/modules/prescription";
import { formSubmitAction } from "./rxFormActions";
import CalcJointSphCyl from "@/lib/lens/calcSphCyl";
import variable from "@/src/styles/variables.module.scss";
import { useTranslation } from "@/src/i18n/client";
import RxTitle from "@/src/components/RxComponent/RxTitle";
import BirthYear from "@/src/components/RxComponent/BirthYear";
import PD from "@/src/components/RxComponent/PD";
import ODOS from "@/src/components/RxComponent/ODOS";
import ADD from "@/src/components/RxComponent/ADD";

/**
 * 1.点击展开
 * 2.填写验证
 * 3.关闭清空
 * 4.点击按钮各种校验
 * 5.提交成功
 */
let SPH = false;
let CYL = false;
let testPd = false;

export type IFormData = Omit<IPrescriptionDataItem, "prescription"> &
    Partial<IInsertGetPrescription>;
interface IProps {
    id?: number;
    isHideImgRx: boolean;
    isShowAttachment: boolean;
    ecenttic?: any; // 不知道是啥
    submitRx: (
        res: { rx: string; attachment: any },
        v: IFormData,
        cancel: () => void,
    ) => void;
    rxId?: any;
    // type?: string;
}

const emojiRegex =
    /[\u{1F600}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}\u{1F191}-\u{1F251}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F300}-\u{1F5FF}\u{1F900}-\u{1F9FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F300}-\u{1F5FF}\u{1F900}-\u{1F9FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F300}-\u{1F5FF}\u{1F900}-\u{1F9FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F300}-\u{1F5FF}\u{1F900}-\u{1F9FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F300}-\u{1F5FF}\u{1F900}-\u{1F9FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F300}-\u{1F5FF}\u{1F900}-\u{1F9FF}]/gu;
// 1.校验格式（必填项）2.确认pd啥的，3.表单值确认

function addIconInsertBeforeValue(value: number | string | null) {
    return parseFloat(String(value ?? "0")) > 0
        ? `+${parseFloat(String(value ?? "0")).toFixed(2)}`
        : value;
}

export interface IErrorList {
    ODError: string;
    OSError: string;
    chooseError: string;
    AttachmentUploadError: string;
    PDError: string;
    nameError: string;
    termError: string;
}

const initError = {
    ODError: "",
    OSError: "",
    chooseError: "",
    AttachmentUploadError: "",
    PDError: "",
    nameError: "",
    termError: "",
};
const RxForm: React.FC<IProps> = (props) => {
    const { submitRx, isHideImgRx, isShowAttachment } = props;
    const { pending } = useFormStatus();
    const [openModal] = signInModal.useSignInModalStore((state) => [
        state.openModal,
    ]);
    const [
        activeData,
        dataPrescription,
        setPrescription,
        setActiveData,
        getRxS,
    ] = usePrescriptionContext((state) => [
        state.activeData,
        state.data,
        state.setPrescription,
        state.setActiveData,
        state.getRxS,
    ]);
    const [loginedPrescriptionOpen, setLoginedPrescriptionOpen] =
        useState(false);
    const [lensInfoData] = lensInfo.useLensInfoStore((state) => [state.data]);
    const [dialogChildren, setDialogChildren] = useState<ReactNode>(<></>);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogRenderBottom, setDialogRenderBottom] = useState<ReactNode>();
    const { site, host } = useCommonContext();
    const { t } = useTranslation(["common", "lens", "rx"]);

    const [productDetail] = useProductDetailsContext((state) => [
        state.productDetail,
    ]);
    const [showCantUseThisPrescription, setShowCantUseThisPrescription] =
        useState(false);
    // 点击弹窗展示的眼镜度数数据
    const selectedInit = useMemo<Record<string, number[]>>(() => {
        return getRxSelect(
            new Function(getSiteConfiguration("rxSelect", host))()(),
        );
    }, [host]);
    const [isShowRxConfirm, setIsShowRxConfirm] = useState(false);
    const [isChange, setIsChange] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [errors, setErrors] = useState<IErrorList>(initError);
    const [attachmentPploading, setAttachmentPploading] = useState(false);

    const alertInfo = useCallback(
        (message: any) => {
            setDialogOpen(true);
            setDialogChildren(t(`rx:${message}`));
            setDialogTitle(t("common:Reminder"));
            setDialogRenderBottom(
                <FmButton
                    onClick={() => console.log("cancel")}
                    fullWidth
                    variant="outlined"
                    size={"large"}
                >
                    {t("common:Ok")}
                </FmButton>,
            );
        },
        [t],
    );

    const alertConfirm = useCallback(
        (message: string, sure: () => void) => {
            if (!props.ecenttic) {
                setDialogOpen(true);
                setDialogChildren(t(`rx:${message}`));
                setDialogTitle(t("common:Reminder"));
                setDialogRenderBottom(
                    <>
                        <FmButton
                            onClick={() => {
                                typeof sure == "function" && sure();
                            }}
                            size={"large"}
                            fullWidth
                        >
                            {t("rx:Sure")}
                        </FmButton>
                        <FmButton
                            style={{
                                marginTop: "0.2rem",
                            }}
                            onClick={() => console.log("cancel")}
                            size={"large"}
                            variant="outlined"
                            fullWidth
                        >
                            {t("rx:CheckAgain")}
                        </FmButton>
                    </>,
                );
            } else {
                typeof sure == "function" && sure();
            }
            return;
        },
        [props.ecenttic, t],
    );

    const rxFormSubmit = useCallback(
        async (value: IFormData) => {
            SPH = false;
            CYL = false;
            testPd = false;

            try {
                const res = await formSubmitAction(value);

                // setSubmitting(false);
                setCookieItem(RX_STR_COOKIE_NAME, res.rx, {
                    path: "/",
                });
                setCookieItem(RX_COOKIE_NAME, JSON.stringify(value), {
                    path: "/",
                });
                if (isLogin()) {
                    getRxS().then(() => {
                        setActiveData({ type: -1 });
                        // setSubmitting(false);
                    });
                }
                submitRx?.(res, value, () => {
                    // setSubmitting(false);
                });
            } catch (e: any) {
                // setSubmitting(false);
                setDialogOpen(true);
                setDialogChildren(e?.message);
                setDialogRenderBottom(
                    <FmButton
                        onClick={() => console.log("cancel")}
                        fullWidth
                        variant="outlined"
                        size={"large"}
                    >
                        {t("common:Ok")}
                    </FmButton>,
                );
            }
        },
        [getRxS, setActiveData, submitRx, t],
    );

    const openRxConfirm = useCallback(
        (value?: IFormData) => {
            setIsShowRxConfirm(true);
            value && setActiveData(value);
        },
        [setActiveData],
    );

    const checkFrom = useCallback(
        (value: IFormData) => {
            if (Number(value.type) === 0) {
                if (
                    value.od_sph &&
                    value.os_sph &&
                    (value.od_sph as number) * (value.os_sph as number) < 0 &&
                    !SPH &&
                    isChange
                ) {
                    console.log("alertconfirm-sphError");

                    alertConfirm("sphError", () => {
                        SPH = true;
                        checkFrom(value);
                    });
                    // setSubmitting(false);
                    return false;
                }
                if (
                    value.od_cyl &&
                    value.os_cyl &&
                    (value.od_cyl as number) * (value.os_cyl as number) < 0 &&
                    !CYL &&
                    isChange
                ) {
                    console.log("alertconfirm-cylError");
                    alertConfirm("cylError", () => {
                        CYL = true;
                        checkFrom(value);
                    });
                    // setSubmitting(false);
                    return false;
                }
            }

            if (
                !activeData.twoPD &&
                value.pd &&
                ((value.pd as number) <= 50 || (value.pd as number) >= 80) &&
                !testPd &&
                isChange
            ) {
                console.log("alertconfirm-pd");

                alertConfirm("pdError", () => {
                    testPd = true;
                    checkFrom(value);
                });
                // setSubmitting(false);
                return false;
            }
            if (isChange && Number(value.type) === 0 && !props.ecenttic) {
                console.log("toggle-rx-confirm");

                openRxConfirm(value);
                return;
            } else {
                rxFormSubmit(value);
            }
        },
        [
            activeData.twoPD,
            alertConfirm,
            isChange,
            props.ecenttic,
            rxFormSubmit,
            openRxConfirm,
        ],
    );

    // 这个要来： RxList: state.getRx
    const products_have_sunmode = useMemo(
        () =>
            lensInfoData.product.products_have_sunmode !== undefined
                ? lensInfoData.product.products_have_sunmode
                : productDetail.products_have_sunmode,
        [
            lensInfoData.product.products_have_sunmode,
            productDetail.products_have_sunmode,
        ],
    );

    const toggleCantUseThisPrescription = useCallback(
        (showPrescription: boolean) => {
            setShowCantUseThisPrescription(showPrescription);
        },
        [],
    );

    const changeImg = (imgUrl = "") => {
        setPrescription({
            image_file_url: imgUrl,
        });
    };
    const changeUploading = (v: any) => {
        setUploading(v);
    };

    const rxInfo = useCallback((data: IPrescriptionDataItem) => {
        let activeData: Partial<IPrescriptionDataItem> = {};
        const { pres_name, ...rest } = data;
        activeData = {
            ...rest,
            prescription: {
                image_file_url: data.prescription.rx_type_val,
                ...data.prescription,
            },
            prescription_name: pres_name,
        };
        if (
            activeData.prescription?.left_pd ||
            activeData.prescription?.right_pd
        ) {
            activeData.twoPD = true;
        } else {
            activeData.twoPD = false;
        }
        return activeData;
    }, []);

    const addNew = useCallback(
        (obj?: any) => {
            const tempData = rxInfo({ ...initActiveData, ...obj });
            console.log("tempData-add-new", tempData);

            setActiveData(tempData);
        },
        [rxInfo, setActiveData],
    );

    // 初始渲染
    useEffect(() => {
        if (isLogin()) {
            addNew({ type: -1 });
            getRxS();
        } else {
            const valueLocal: any = getCookieItem(RX_COOKIE_NAME);
            let valueLocal_json: any = "";
            try {
                valueLocal_json = valueLocal ? JSON.parse(valueLocal) : "";
            } catch (error) {
                console.error("RxForm", error);
            }
            if (valueLocal_json) {
                let data = { ...valueLocal_json };
                if (data.left_pd || data.right_pd) {
                    data.twoPD = true;
                } else {
                    data.twoPD = false;
                }
                setActiveData(data);
            } else {
                addNew();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // const rxDelete = (id: number) => {
    //     deleteRxN(id)
    //         .then((data) => {
    //             showToast(t("common:SUCCESS"));
    //             getRxS().then(() => {
    //                 setActiveData({ type: -1 });
    //             });
    //         })
    //         .catch((e) => {
    //             showToast(e);
    //         });
    // };

    const rxGetN = useCallback(
        async (open: boolean, value?: string | number) => {
            try {
                setLoginedPrescriptionOpen(open);
                if (!value) {
                    setActiveData(rxInfo(activeData));
                    return;
                }
                const { pres_name, ...data } = await getRxN(value as number);
                const tempData = {
                    ...data,
                    pres_id: data.pres_id.toString(),
                    prescription_name: pres_name,
                };
                console.log("data-in-getRxn", data);

                tempData.prescription = {
                    ...tempData.prescription,
                };
                setActiveData(
                    rxInfo({
                        ...dataPrescription?.prescription.filter(
                            (item) => item.pres_id === value,
                        ),
                        ...tempData,
                    }),
                );
            } catch (e) {
                throw e;
            }
        },
        [activeData, dataPrescription, rxInfo, setActiveData],
    );

    // const showModal = (key: any) => (e: any) => {
    //     e.preventDefault(); // 修复 Android 上点击穿透
    //     this.setState({
    //         [key]: true,
    //     });
    // };

    // const onClose = (key: any) => () => {
    //     this.setState({
    //         [key]: false,
    //     });
    // };

    // 表示状态在button点击disabled以后更新过
    const handleChange = () => {
        const { prescription, ...rest } = activeData;
        handleValidate({ ...rest, ...prescription });
    };

    const handleukAcceptTermsChange = () => {
        // const { setFieldValue, values } = props;
        // setFieldValue("ukAcceptTerms", !values.ukAcceptTerms);
    };

    const renderTerms = useMemo(() => {
        const { ukAcceptTerms } = activeData;
        return (
            <>
                <div className={stl["term-box"]}>
                    {/* <FmRadio
                        onChange={handleukAcceptTermsChange}
                        // checked={ukAcceptTerms ? "checked" : ""}
                    /> */}
                    <div className={stl["right-box"]}>
                        <div>
                            <span style={{ color: "#333" }}>*</span>I confirm
                            that I&apos;ve read and agree to the *
                            <FmLink
                                style={{
                                    color: "#333",
                                    textDecoration: "none",
                                }}
                                href="/help-p-238.shtml"
                                target="_blank"
                            >
                                Terms and Conditions
                            </FmLink>
                            :
                        </div>
                        <div>
                            I confirm that the spectacle wearer(s) is/are over
                            16 years old, and the wearer(s) is/are not
                            registered blind, partially blind, or sight
                            impaired.
                        </div>
                        <div>
                            I confirm that the prescription details above have
                            been entered correctly and within 2 years of
                            validity. Besides, there is no BVD on the
                            prescription.
                        </div>
                        <div>
                            Notice: If BVD value is written on you prescription,
                            or the reading prescription exceeds +5.00, or the
                            magnification exceeds +4.00, please visit your eye
                            doctor to get glasses.
                        </div>
                    </div>
                </div>
                {!ukAcceptTerms && errors.termError && (
                    <div className="error C-form-error">{errors.termError}</div>
                )}
            </>
        );
    }, [activeData, errors.termError]);

    // 此处有个红字，暂时没有想出解决办法
    if (
        !props.rxId &&
        Number(activeData.type) === -1 &&
        Number(activeData.type) !== -1
    ) {
        setActiveData(rxInfo(activeData));
    }

    //是否展示附件上传入口
    const isShowAttachmentUpload = useMemo(
        () => Number(activeData.type) === 0 && isShowAttachment,
        [activeData.type, isShowAttachment],
    );

    const disable = useMemo(() => {
        // trim.length > 0 则表示是error
        return (
            !isChange &&
            !!Object.entries(errors).filter((item) => item[1].trim().length > 0)
                .length
        );
    }, [errors, isChange]);

    const handleValidate = useCallback(
        (values: IFormData) => {
            const errorList = { ...initError }; // 复制一份，不要用原件
            if (Number(values.type) === 0) {
                if (
                    values.od_sph ||
                    values.od_cyl ||
                    values.os_sph ||
                    values.os_cyl ||
                    values.add
                ) {
                    if (values.od_cyl && values.od_axis === null) {
                        errorList.ODError = t("rx:ODError");
                    }
                    if (values.os_cyl && values.os_axis === null) {
                        errorList.OSError = t("rx:OSError");
                    }
                } else {
                    errorList.chooseError = t("rx:chooseError");
                }

                //风控产品没有上传附件处方，提示必填
                if (props.isShowAttachment && !values.attachment) {
                    errorList.AttachmentUploadError = t(
                        "rx:AttachmentUploadError",
                    );
                }
            }

            if (
                (!activeData.twoPD && !values.pd) ||
                (activeData.twoPD && (!values.left_pd || !values.right_pd))
            ) {
                errorList.PDError = t("rx:PDError");
            }
            if (!values.prescription_name) {
                errorList.nameError = t("lens:PLEASENAMEYOURPRESCRIPTION");
            }

            if (site === "uk" && !values.ukAcceptTerms) {
                errorList.termError =
                    "please agree to the Terms and Conditions!";
            }
            setErrors((prev) => {
                return { ...prev, ...errorList };
            });
            // 有error & 有文案
            console.log(errorList);

            return (
                Object.entries(errorList).filter(
                    (item) => item[1].trim().length > 0,
                ).length > 0
            );
        },
        [activeData.twoPD, props.isShowAttachment, site, t],
    );

    const prescriptionValueDefaultOption = useMemo(() => {
        return { label: t("rx:SelectText"), value: "pres_name_select" };
    }, [t]);
    const prescriptionValue = useMemo(() => {
        const temp: { label: string; value: number | string }[] = (
            dataPrescription?.prescription ?? []
        ).map((item) => {
            return {
                label: item.pres_name ?? "",
                value: item.pres_id!,
            };
        });
        temp.unshift(prescriptionValueDefaultOption);
        return temp;
    }, [dataPrescription?.prescription, prescriptionValueDefaultOption]);

    const handleSubmit = useCallback(
        (formData: IFormData) => {
            let value;
            if (Number(formData.type) === 0) {
                value = {
                    type: formData.type,
                    od_sph: addIconInsertBeforeValue(formData.od_sph ?? null),
                    od_cyl: addIconInsertBeforeValue(formData.od_cyl ?? null),
                    od_axis: formData.od_axis,
                    os_sph: addIconInsertBeforeValue(formData.os_sph ?? null),
                    os_cyl: addIconInsertBeforeValue(formData.os_cyl ?? null),
                    os_axis: formData.os_axis,
                    add: formData.add,
                    birth_year: formData.birth_year,
                    pres_id: formData.pres_id,
                    pd: formData.pd,
                    left_pd: formData.left_pd,
                    right_pd: formData.right_pd,
                    // option: formData.option,
                    prescription_name: formData.prescription_name.replace(
                        emojiRegex,
                        "?",
                    ),
                    attachment: isShowAttachment ? formData.attachment : "",
                };
            } else if (Number(formData.type) === 1) {
                if (!formData.image_file_url) {
                    alertInfo("imgError");
                    return false;
                }
                value = {
                    type: formData.type,
                    image_file_url: formData.image_file_url,
                    birth_year: formData.birth_year,
                    pres_id: formData.pres_id,
                    // option: formData.option,
                    prescription_name: formData.prescription_name.replace(
                        emojiRegex,
                        "?",
                    ),
                    attachment: "",
                };
            }

            // 套镜需要判断处方 满足下边条件需要给出用户提示 阻止往下一步
            // SPH为正 有联合光度：联合光度 ≥ +6.00 无联合光度：SPH ≥ +6.00
            // SPH为负 SPH ≤ -10.00
            if (Number(formData.type) === 0 && products_have_sunmode) {
                const od_sph = Number(value?.od_sph ?? 0);
                const od_cyl = Number(value?.od_cyl ?? 0);
                const os_sph = Number(value?.os_sph ?? 0);
                const os_cyl = Number(value?.os_cyl ?? 0);

                const checkSphCyl = (sph: number, cyl: number) => {
                    if (sph >= 0) {
                        // sph为正
                        const { unitLumi } = new CalcJointSphCyl(sph, cyl);
                        if (typeof unitLumi === "number") {
                            if (unitLumi >= 6) {
                                // 有联合光度 并且 大于 6
                                return true;
                            }
                        } else if (sph >= 6) {
                            // 没有联合光度
                            return true;
                        }
                    } else if (sph < -10) {
                        // sph为负
                        return true;
                    }
                };
                if (
                    checkSphCyl(od_sph, od_cyl) ||
                    checkSphCyl(os_sph, os_cyl)
                ) {
                    toggleCantUseThisPrescription(true);

                    return false;
                }
            }

            value && checkFrom(value);
        },
        [
            alertInfo,
            checkFrom,
            isShowAttachment,
            products_have_sunmode,
            toggleCantUseThisPrescription,
        ],
    );

    const handleSubmitAction = useCallback(
        (e: any) => {
            // 有设置name坑位会被设置到formdata的位置上
            setIsChange(false);

            e.preventDefault();
            const formData = new FormData(e.target);

            // formData的一些属性因为要设置默认值，所以获取到的值是默认值而不是空，需要做个过滤替换处理
            const defaultValue: Partial<Record<keyof IFormData, string>> = {
                add: t("lens:Rx.n/a"),
                birth_year: t("lens:Rx.Select"),
                od_axis: t("lens:Rx.None"),
                od_cyl: t("lens:Rx.None/SPH"),
                od_sph: t("lens:Rx.None/PL"),
                os_axis: t("lens:Rx.None"),
                os_cyl: t("lens:Rx.None/SPH"),
                os_sph: t("lens:Rx.None/PL"),
                pd: t("lens:Rx.SeletPd"),
                left_pd: t("lens:Rx.LeftPD"),
                right_pd: t("lens:Rx.RightPD"),
            };

            const values = Object.fromEntries(formData) as unknown as Record<
                string,
                any
            >;

            for (let key of Object.keys(defaultValue)) {
                if (isNaN(Number(values[key]))) {
                    values[key] = null;
                }
            }
            const validateVal = handleValidate(values as IFormData);
            setIsChange(!validateVal);
            if (validateVal) {
                return;
            }
            handleSubmit(values as IFormData);
        },
        [handleSubmit, handleValidate, t],
    );

    return (
        <>
            <FmDrawer
                anchor="bottom"
                closeablePosition="right"
                open={dialogOpen}
                headerChildren={dialogTitle}
                closeable
                footerClassName={stl["footer-container"]}
                footer={dialogRenderBottom}
                onClose={() => setDialogOpen(false)}
            >
                {dialogChildren}
            </FmDrawer>
            <div
                className={classnames(stl["rx"], stl["rx-form-content"], {
                    [stl["hidden-img-rx"]]: isHideImgRx,
                })}
            >
                {isLogin() ? (
                    <div
                        className={classnames(
                            "default_layout",
                            stl["logged-container"],
                        )}
                    >
                        <FmPicker
                            open={loginedPrescriptionOpen}
                            value={
                                activeData.pres_id ??
                                prescriptionValueDefaultOption.value
                            }
                            inputClassName={classnames(
                                stl["input-container"],
                                activeData.pres_id?.toString(),
                            )}
                            onChange={rxGetN}
                            confirm="confirm"
                            cancel="cancel"
                            dataSource={prescriptionValue}
                            disabled={prescriptionValue.length === 1}
                        />
                        <FmButton
                            style={{
                                marginLeft: "5px",
                            }}
                            variant="text"
                            // 这里一定要这么写，不然把click的参数e传进去了
                            onClick={() => addNew()}
                        >
                            {t("lens:ADD_NEW")}
                        </FmButton>
                    </div>
                ) : (
                    <div
                        className={classnames(
                            "default_layout",
                            stl["unlogin-to-use-prescription"],
                        )}
                    >
                        <FmButton onClick={() => openModal()} variant="text">
                            {t("common:LOGIN")}
                        </FmButton>
                        <span className={stl["lens-use-your-saved"]}>
                            {t("lens:USE_YOUR_SAVED_PRESCRIPTION")}
                        </span>
                    </div>
                )}

                {/* 这个模块存在的意义没整明白 */}
                {!isHideImgRx && (
                    <div
                        className={classnames(
                            "default_layout",
                            stl["hide-img-rx"],
                        )}
                    >
                        {Number(activeData.type) === 1 ? (
                            <div
                                onClick={(e) => {
                                    setActiveData({ type: 0 });
                                }}
                                style={{
                                    cursor: "pointer",
                                    color: variable.main,
                                }}
                            >
                                {t("rx:FillForm")}
                            </div>
                        ) : (
                            <div
                                onClick={(e) => {
                                    setActiveData({ type: 1 });
                                }}
                                style={{
                                    cursor: "pointer",
                                    color: variable.main,
                                }}
                            >
                                {t("rx:UploadPrescription")}
                            </div>
                        )}
                    </div>
                )}
    
                <form
                    onSubmit={handleSubmitAction}
                    className={classnames(stl["rx_form"], {
                        [stl["hide-img-rx-form"]]: isHideImgRx,
                    })}
                >
                    {activeData?.pres_id && (
                        <input
                            type="hidden"
                            value={activeData.pres_id}
                            name={"pers_id"}
                        />
                    )}
                    <input
                        type="hidden"
                        name={"type"}
                        value={activeData.type}
                    />
                    <div className={stl["rxBorder"]}>
                        {Number(activeData.type) === 0 && (
                            <div
                                className={
                                    stl[`values-${activeData.type}-container`]
                                }
                            >
                                <ODOS
                                    selectData={selectedInit}
                                    errors={errors}
                                    onChange={handleChange}
                                />
                                <ADD
                                    selectData={selectedInit}
                                    errors={errors}
                                    onChange={handleChange}
                                />
                            </div>
                        )}
                        
                        {Number(activeData.type) === 1 && (
                            <div
                                className={classnames(
                                    "default_layout",
                                    stl[`values-${activeData.type}-container`],
                                )}
                            >
                                <Upload
                                    // name={"image_file_url"} // TODO: 这个要支持
                                    acceptPdf={true}
                                    noZip={true}
                                    change={(imgUrl) =>
                                        changeImg(imgUrl as string)
                                    }
                                    uploading={uploading}
                                    changeUploading={changeUploading}
                                    imgUrl={
                                        activeData.prescription
                                            .image_file_url ?? undefined
                                    }
                                />
                                <div className={stl["upload-type"]}>
                                    {t("rx:jpg")}
                                </div>
                            </div>
                        )}

                        <div className={stl["rx-container"]}>
                            <PD
                                selectData={selectedInit}
                                errors={errors}
                                onChange={handleChange}
                            />
                            <BirthYear
                                selectData={selectedInit}
                                onChange={handleChange}
                            />
                            {isShowAttachmentUpload && (
                                <div style={{ margin: "10px 0" }}>
                                    <RxTitle title={t("rx:FillRx")} />
                                    <div
                                        className="oh"
                                        style={{ display: "flex" }}
                                    >
                                        <Upload
                                            acceptPdf={true}
                                            noZip={true}
                                            change={(imgurl = "") => {
                                                setActiveData({
                                                    attachment:
                                                        imgurl as string,
                                                });
                                                setErrors((prev) => {
                                                    prev.AttachmentUploadError =
                                                        "";
                                                    return prev;
                                                });
                                                setIsChange(true);
                                            }}
                                            uploading={attachmentPploading}
                                            changeUploading={(v: any) => {
                                                setAttachmentPploading(v);
                                            }}
                                            imgUrl={activeData.attachment ?? ""}
                                        />
                                        <div
                                            style={{
                                                paddingLeft: "10px",
                                                lineHeight: "57px",
                                            }}
                                        >
                                            <span>{t("rx:jpg")}</span>
                                        </div>
                                    </div>
                                    {errors.AttachmentUploadError && (
                                        <div className="error m-form-error">
                                            {errors.AttachmentUploadError}
                                        </div>
                                    )}
                                </div>
                            )}
                            <div className={stl["prescription-name"]}>
                                <RxTitle
                                    title={t("lens:Preion")}
                                    className={stl["prescription-title"]}
                                />
                                <FmInput
                                    className={stl["prescription-input"]}
                                    name="prescription_name"
                                    onChange={(e) => {
                                        setActiveData({
                                            prescription_name: e.target.value,
                                        });
                                    }}
                                    onBlur={handleChange}
                                    value={activeData.prescription_name}
                                    placeholder={t("lens:prescription")}
                                    error={errors.nameError.trim().length > 0}
                                    helperText={t(`login:${errors.nameError}`)}
                                    errorPosition="bottom"
                                />
                            </div>
                        </div>
                    </div>
                    {site === "uk" && renderTerms}
                    <div
                        className={classnames("default_layout")}
                        style={{
                            marginTop: "0.5rem",
                            padding: "0.3rem 0",
                            borderTop: `0.02rem solid ${variable.gray_4}`,
                        }}
                    >
                        <FmButton
                            size="medium"
                            style={{
                                width: "3.6rem",
                                height: "0.72rem",
                                lineHeight: "0.72rem",
                            }}
                            loading={pending}
                            type="submit"
                            disabled={
                                site === "uk"
                                    ? !activeData.ukAcceptTerms || disable
                                    : disable
                            }
                        >
                            {t("common:UP_KEYS_CONFIRM")}
                        </FmButton>
                    </div>
                    {/* {type === "account" && activeData.pres_id && (
                    <span
                        className="bt"
                        style={{ border: "none" }}
                        onClick={() => rxDelete(activeData.pres_id as number)}
                    >
                        {t("rx:remove")}
                    </span>
                )} */}
                </form>
                <RxConfirm
                    visible={isShowRxConfirm}
                    onClose={() => setIsShowRxConfirm(false)}
                    Edit={() => setIsShowRxConfirm(false)}
                    Confirm={() => {
                        rxFormSubmit({
                            ...activeData,
                            ...activeData.prescription,
                        });
                        setIsShowRxConfirm(false);
                    }}
                />

                <FmDrawer
                    closeable
                    className={stl["cant-use-prescription"]}
                    open={showCantUseThisPrescription}
                    onClose={() => toggleCantUseThisPrescription(false)}
                    anchor="bottom"
                    closeablePosition="right"
                    footer={
                        <FmButton
                            size="large"
                            fullWidth
                            variant="outlined"
                            // submit={true}
                            disabled={
                                site === "uk"
                                    ? !activeData.ukAcceptTerms || disable
                                    : disable
                            }
                            onClick={() => {
                                window.open(
                                    getSiteConfiguration(
                                        "changeFrameUrl",
                                        host,
                                    ),
                                    "_blank",
                                );
                            }}
                        >
                            {t("common:changeFrame")}
                        </FmButton>
                    }
                >
                    <div className={stl["dialog-content"]}>
                        {t("common:clipOnNotFitFrame")}
                    </div>
                </FmDrawer>
            </div>
        </>
    );
};

export default RxForm;
